<template>
  <router-view />
</template>

<script>
import {
  isPublicRoute
} from "@/router/publicRoute";

export default {
  name: "App",

  data() {
    return {
      sessionExpiryTimer: null,
    };
  },

  mounted() {
    // Verifica a validade da sessão somente em rotas privadas.
    this.sessionExpiryTimer =
      setInterval(
        () => {
          if (
            isPublicRoute(
              this.$route
            )
          ) {
            return;
          }

          const tokenExp =
            localStorage.getItem(
              "token_exp"
            );

          if (tokenExp) {
            const now =
              Math.floor(
                Date.now() / 1000
              );

            if (now > tokenExp) {
              alert(
                "Sua sessão expirou. Faça login novamente."
              );

              localStorage.removeItem(
                "token"
              );

              localStorage.removeItem(
                "token_exp"
              );

              this.$router.push(
                "/login"
              );

              setTimeout(
                () => {
                  window.location.reload();
                },
                100
              );
            }
          }
        },
        60000
      );
  },

  beforeUnmount() {
    if (
      this.sessionExpiryTimer
    ) {
      clearInterval(
        this.sessionExpiryTimer
      );
    }
  },

  methods: {
    logout() {
      localStorage.removeItem(
        "token"
      );

      this.$router.push(
        "/login"
      );
    },
  },
};
</script>

<style>
/* Estilos globais ou comuns, se necessário */

html, body, #app {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
}

h1 {
  margin-top: 0; /* Remove margens superiores padrão */
}

.table thead th button.btn-link {
  color: inherit;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  text-decoration: none;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  cursor: pointer;
}
.table thead th button.btn-link:hover {
  text-decoration: underline;
}

.valor-cell {
  text-align: right !important;
}

</style>
